export class CreateGarantieProduit
{
    code: String;
    label:String;
    produitId:number;
}